// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/list.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file api_proto/v1/list.proto.
 */
export const file_api_proto_v1_list: GenFile = /*@__PURE__*/
  fileDesc("ChdhcGlfcHJvdG8vdjEvbGlzdC5wcm90bxIMYXBpX3Byb3RvLnYxKj0KBU9yZGVyEhUKEU9SREVSX1VOU1BFQ0lGSUVEEAASDQoJT1JERVJfQVNDEAESDgoKT1JERVJfREVTQxACQjNaMWdpdGh1Yi5jb20vaC1zY2FwZS9pZXNhcHVyaS9nby9hcGlfcHJvdG8vdjE7YXBpdjFiBnByb3RvMw");

/**
 * @generated from enum api_proto.v1.Order
 */
export enum Order {
  /**
   * @generated from enum value: ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORDER_ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: ORDER_DESC = 2;
   */
  DESC = 2,
}

/**
 * Describes the enum api_proto.v1.Order.
 */
export const OrderSchema: GenEnum<Order> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_list, 0);

